import SideBar from "./Sidebar";
import Header from "./Header";
import styles from "./index.module.css";
import PageBreadcrumb from "../Breadcrumb";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function Main({ children, pageName, showHeader = true }) {
  const [isDrawerOpen, setToggleDrawer] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className={styles.pageContainer}
    >
      <SideBar />

      <motion.div
        initial={{ x: 20, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.2 }}
        className={styles.contentContainer}
      >
        {showHeader && (
          <AnimatePresence mode="wait">
            <motion.div
              key={pageName}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.2 }}
            >
              <Header pageName={pageName} setToggleDrawer={setToggleDrawer} />
            </motion.div>
          </AnimatePresence>
        )}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
        >
          {children}
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default Main;
